<template>
    <Multiselect id="ms_locations2" class="multiselect-locations multiselect-small" v-model="locationsSelected" mode="multiple"
        :close-on-select="false" :searchable="true" :create-option="false" :object="true" :options="locationsSelectable"
        :hideSelected="false" locale="de" fallback="en" @clear="clearedLocationMultiselect" placeholder="Standort auswählen"
        @deselect="deselectedLocationMultiselect" @select="selectMultiselect"  />
</template>

<style>
.multiselect-locations {
    z-index: 120;
}
</style>


<script>

import Multiselect from '@vueform/multiselect';

import getLocations from "../composables/getLocations";

import { useLocationStore } from "../stores/LocationStore";

export default {

    setup() {
        const { locations, locations_error, loadLocations } = getLocations();
        loadLocations();

        let locationStore = useLocationStore();

        return { locations, locations_error, locationStore: locationStore, };

    },
    name: "MultiselectLocations2",
    components: {
        Multiselect,
    },
    props: {

    },
    emits:['selectedlocationsChanged'],
    data() {
        return {
            optionSelected: "",
            locationsSelected: [],
        }
    },
    mounted() {
        this.locationsSelected = this.locationStore.locations;
        let url = new URL(window.location.href);
        var params = [];
        params = url.searchParams.get('location');
        var selectedLocationIds = [];
        this.locationsSelected.forEach(element => {
            const locationId =
                element.value
                ;
            if (locationId != []) {
                selectedLocationIds.push(locationId);
            }
        });
    },
    watch: {
        locationsSelected(newValue, oldValue) {
            this.locationStore.locations = this.locationsSelected;
            this.$emit('selectedlocationsChanged',this.locationsSelected);
        }
    },
    computed: {
        locationsSelectable() {
            var items = [];
            if (this.locations) {
                this.locations.forEach(element => {
                    const location = {
                        value: element.id,
                        label: { en: element.name },
                    };
                    items.push(location);
                });
            }
            return items;
        },
    },
    methods: {
        clearedLocationMultiselect() {
            this.locationsSelected = []; 

        },
        deselectedLocationMultiselect() {
            if (this.locationsSelected.length == 0) {
                this.locationsSelected = [];
            }
        },
        selectMultiselect() {
            if (this.locationsSelected.length > 0) {
                const allOptionSelected = this.locationsSelected.find((locationSelected) => locationSelected.value == []);
                if (allOptionSelected != null) {
                    this.locationsSelected = this.locationsSelected.filter((locationSelected) => locationSelected.value != 9999);
                }
            }
        },
    }
}

</script>
<style scoped>
.multiselect-small {
    --ms-font-size: 0.8rem;
}
</style>>

